export default __webpack_public_path__ + "static/media/laptop.c26b50b9.jpeg";